.appContainer {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100vh;

  @media print {
    display: block;
  }
}

.routeViewContainer {
  flex: 1 0 auto;
  position: relative;
}
